<template>
	<div class="copy-right-sigin">
		<h2>版权注册</h2>
		<div class="copy-right-sigin.form">
			<el-form :model="copyRightSiginForm" :rules="copyRightFormRules" ref="copyRightForm" label-width="100px" class="demo-ruleForm">
				<el-form-item prop="name">
					<el-input v-model="copyRightSiginForm.name" placeholder="版权名称"></el-input>
				</el-form-item>
				<el-form-item prop="type">
					<el-select v-model="copyRightSiginForm.type" placeholder="版权类型">
						<el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item prop="fast">
					<el-select v-model="copyRightSiginForm.fast" placeholder="是否加急">
						<el-option v-for="item in fastOptions" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item prop="part">
					<el-select v-model="copyRightSiginForm.part" placeholder="版权登记部门">
						<el-option v-for="item in partOptions" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item prop="phone">
					<el-input v-model="copyRightSiginForm.phone" placeholder="联系电话"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="submitForm('copyRightForm')">我要注册</el-button>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
	import '../fetch/formatDate';
	import checkPhone from '../fetch/checkPhone';
	export default {
		data() {
			return {
				typeOptions: [{
					value: '软件著作权',
					label: '软件著作权'
				}, {
					value: '美术作品',
					label: '美术作品'
				},{
					label: '文字作品',
					value: '文字作品'
				},{
					label: '音乐作品 ',
					value: '音乐作品 '
				},{
					label: '摄影作品',
					value: '摄影作品'
				},{
					label: '模型作品',
					value: '模型作品'
				},{
					label: '录像作品',
					value: '录像作品'
				},{
					label: '其他作品',
					value: '其他作品'
				}],
				fastOptions: [{
					value: '31个工作日以上',
					label: '31个工作日以上'
				}, {
					value: '26到30个工作日',
					label: '26到30个工作日'
				},{
					value: '21到25个工作日',
					label: '21到25个工作日'
				},{
					value: '16到20个工作日',
					label: '16到20个工作日'
				},{
					value: '11到15个工作日',
					label: '11到15个工作日'
				},{
					value: '6到10个工作日',
					label: '6到10个工作日'
				},{
					value: '5个工作日',
					label: '5个工作日'
				},{
					value: '4个工作日',
					label: '4个工作日'
				},{
					value: '3个工作日',
					label: '3个工作日'
				},{
					value: '2个工作日',
					label: '2个工作日'
				},{
					value: '1个工作日',
					label: '1个工作日'
				}],
				partOptions: [{
					value: '国家版权局',
					label: '国家版权局'
				}, {
					value: '甘肃省版权局',
					label: '甘肃省版权局'
				}],
				copyRightSiginForm: {
					name: '',
					type: '',
					fast: '',
					part: '',
					phone:''
				},
				copyRightFormRules: {
					name: [{
						required: true,
						message: '请填写版权名称',
						trigger: 'blur'
					}],
					type: [{
						required: true,
						message: '请选择版权类型',
						trigger: 'change'
					}],
					fast: [{
						required: true,
						message: '请选择',
						trigger: 'change'
					}],
					part: [{
						required: true,
						message: '请选择',
						trigger: 'change'
					}],
					phone: [{validator: checkPhone, trigger: 'blur',required:true}]

				}
			}
		},
		methods: {
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.http.post('IPR_Need',{
							  content:'版权名称：' + this.copyRightSiginForm.name +',版权类型：' + this.copyRightSiginForm.type +'，时间节点：' + this.copyRightSiginForm.fast +'，登记部门：'+this.copyRightSiginForm.part,
							  phone :this.copyRightSiginForm.phone,
							  type: 3, //版权注册
							  name:'版权注册测试人员' ,
							  date_time: new Date().format("yyyy-MM-dd hh:mm:ss"),
						}).then(res => {
							if(res.code == 0){
								this.$emit('showTipsEvent', true)
							    this.$refs[formName].resetFields();
							}
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			}
		}
	}
</script>

<style lang="scss">
	@include component(copy-right-sigin) {
		width: 100%;
		//height:350px;
		background: linear-gradient(135deg, rgba(84, 167, 240, 1) 0%, rgba(137, 200, 255, 1) 100%);
		box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
		color: #fff;

		h2 {
			margin: 0;
			font-size: 24px;
			text-align: center;
			padding-top: 19px;
			padding-bottom: 16px;
		}

		@include part(form) {
			width: 190px;
			margin: 0 auto;

			@include component(el-form-item__content) {
				margin-left: 0 !important;
			}

			@include component(el-form) {
				padding-bottom: 5px;

			}

			@include component(el-form-item) {
				margin-bottom: 15px;
			}

			@include component(el-button) {
				width: 100%;
				background: #F47227;
				border: none;
			}

			@include component(el-form-item__error) {
				top: 91%;
			}

			@include component(el-input__inner) {
				border: none;
				outline: none;
			}

			@include component(el-button--primary) {
				background: linear-gradient(90deg, rgba(255, 155, 0, 1) 0%, rgba(254, 191, 0, 1) 100%);
				box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.2);
				border-radius: 5px;
				font-weight: bold;
				font-size: 18px;

				&:active,
				&:hover,
				&:focus {
					background: linear-gradient(90deg, rgba(255, 155, 0, 1) 0%, rgba(254, 191, 0, 1) 100%);

				}

				&.is-active {
					background: linear-gradient(90deg, rgba(255, 155, 0, 1) 0%, rgba(254, 191, 0, 1) 100%);

				}
			}
		}
	}
</style>
